<template>
  <div>
    <div class="list_item"
         v-for="(item,index) in list"
         :key="index ">
      <span>{{item.materialName}}</span>
      <a class="submitBtn"
         :href="item.materialContent"
         download
         v-if="item.whetherMandatoryRead == 'http'">
        <img class="img_"
             src="../../../assets/image/bs-2.0/down-red.png"
             alt="">
        <!-- <img class="img_" src="../../../assets/image/bs-2.0/down-red.png" alt="" @click="downLoad(item.materialContent,item.materialName)"> -->
      </a>
      <a @click="show(item.materialContent)" v-else>查看</a>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.list_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 20px;
  background-color: #f8f8f8;
  border-radius: 10px;
  color: #333333;
  font-size: 15px;
  // height: 50px;
  // line-height: 50px;
  padding: 12px 26px;
  text-align: left;
  line-height: 20px;
  .img_ {
    width: 10px;
    height: 11px;
  }
}
.content {
  width: 100%;
  background-color: #fff;
  overflow: auto;
}
</style>

<script>
import api from '@/utils/api'
const positions = ['center']
let title = ''
// document.title = this.title
export default {
  data() {
    return {
      content: '',
      title,
      query: {},
      title: '',
      list: [],
      data: {},
      position: ''
    }
  },
  created() {
    this.query = this.$route.query
    this.queryWxMaterial()
  },
  methods: {
    show(materialContent) {
      this.$router.push({
        name: 'article',
        params: {
          content: materialContent
        }
      })
    },
    queryWxMaterial() {

      this.list = []
      let customerNotificationList = []

      api.queryWxMaterial({
        productCode: this.query.code,
        userId: this.query.userid,
        mainId: this.query.mainId
      }).then(res => res.data).then(data => {
        this.data = data.content
        customerNotificationList.push({
          materialName: '客户告知书',
          materialContent: data.content.customerTemplate,
          whetherMandatoryRead: 'http'
        })
        this.data['customerNotification'] = customerNotificationList
        this.getListByType(this.query.type)
      })
    },
    getListByType(type) {
      let title = ''
      if (type == '2') {
        title = '产品条款'
        this.list = this.data['productTerms']
      } else if (type == '5') {
        title = '投保须知'
        this.list = this.data['insurances']
      } else if (type == '6') {
        title = '职业类别'
        this.list = this.data['occupationCategories']
      } else if (type == '15') {
        title = '培训课件'
        this.list = this.data['trainingCourseware']
      } else if (type == '12') {
        title = '直播课堂'
        this.list = this.data['liveClass']
      }
       else if (type == '10') {
        title = '客户告知书'
        this.list = this.data['customerNotification']
        console.log('customerNotification', this.list);
      }
      else if (type == '99') {
        title = '其他'
        this.list = this.data['others']
      }
      this.title = title
    }
  }
}
</script>
